var _path, _circle, _path2, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalSilver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31324 18.4664H31.8775V38.4086C31.8775 39.8441 30.4581 40.8481 29.1046 40.3702L20.0954 37.1888L11.0862 40.3702C9.73267 40.8481 8.31324 39.8441 8.31324 38.4086V18.4664Z",
    fill: "#AAC1D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0941,
    cy: 20.0942,
    r: 14.4004,
    transform: "rotate(35.6401 20.0941 20.0942)",
    fill: "#C2D1DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7035 31.7973C18.1669 36.4315 27.1633 34.9486 31.7976 28.4852L8.39137 11.7032C3.75715 18.1666 5.24003 27.1631 11.7035 31.7973Z",
    fill: "#D6E4EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.096,
    cy: 20.0942,
    r: 12.9004,
    transform: "rotate(35.6401 20.096 20.0942)",
    stroke: "#AAC1D4",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSilver);
export default __webpack_public_path__ + "static/media/medal-silver.c9d5ed389525544519fed3e2eb759305.svg";
export { ForwardRef as ReactComponent };